import React from "react";
import "primeicons/primeicons.css";
import { BreadCrumb } from "primereact/breadcrumb";
import FitIndiaSchoolLogo from "../assets/fit-india-school.svg";
import schoolImg from "../assets/school.jpeg";

function PublicHeader({ breadcrumb, title }) {
  const home = { label: "Home", url: "https://stjudesonline.in/" };

  return (
    <header>
      <div className="col-md-12 text-center top-menu">
        <div className="row p-20">
          <div className="col-12 md:col-12 xl:col-6" style={{ width: "50%" }}>
            <div className="row">
              <div className="mr-3">
                <i className="pi pi-phone  mr-2 nav-icon"></i>
                <a href="tel:04266 275709 (32 Lines)">
                  04266 275709 (32 Lines)
                </a>
              </div>
              <div className="">
                <i className="pi pi-phone  mr-2 nav-icon"></i>
                <a href="tel:04266 275809 (32 Lines)">
                  04266 275809 (32 Lines)
                </a>
              </div>
            </div>
          </div>
          <div className="col-12 md:col-12 xl:col-6" style={{ width: "50%" }}>
            <div className="row pull-right">
              <a href="https://stjudesonline.in/">
                {/* <i className="pi pi-phone" style={{ fontSize: ".8rem" }}></i> */}
                <span className="">
                  <span>HOME</span>
                </span>
              </a>
              <span className="unit-left">
                <span className="">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
              </span>
              <a href="https://portal.stjudesonline.in/">
                {/* <i className="pi pi-phone" style={{ fontSize: ".8rem" }}></i> */}
                <span className="">
                  <span> PARENT PORTAL</span>
                </span>
              </a>
              <span className="unit-left">
                <span className="">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
              </span>
              <a
                href="https://quickpay.stjudesonline.in/"
                className="quickpay ml-2"
                target="_blank"
              >
                <span className="unit-body">
                  <span> QUICK PAY</span>
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="col-md-12">
        <div className="row main-nav-bar">
          <div className="school-logo">
            <a href="http://www.stjudesonline.in">
              <img
                src={require("../assets/logo.png")}
                alt="Logo"
                width={"100%"}
              />
            </a>
          </div>
          <div className="fit-india">
            <div className="float-right">
              <a href="http://www.stjudesonline.in">
                <img src={FitIndiaSchoolLogo} alt="Logo" width={"70%"} />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="sub-nav-bar-outer"></div>

      <section
        class="section parallax-container bg-black"
        data-parallax-img={schoolImg}
      >
        <div class="material-parallax parallax">
          <img
            src={schoolImg}
            alt=""
            style={{
              display: "block",
              transform: "translate3d(-50%, 129px, 0px)",
            }}
          />
        </div>
        <div class="parallax-content section section-sm context-dark overlay-5">
          <div class="container">
            <div class="row justify-content-sm-center justify-content-lg-start">
              <div class="col-md-12 offset-top-10 text-center w-full">
                <div className="public-title">
                  <div className="main-title">
                    <h1>{title}</h1>
                  </div>
                </div>
                <div className="public-bread-crumbs">
                  <div className="bread-crumbs">
                    <BreadCrumb model={breadcrumb} home={home} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div
        className=""
        style={{
          position: "relative",
          // top: "-15px",
        }}
      ></div>
    </header>
  );
}

export default PublicHeader;
